import { cva } from "class-variance-authority";

export const comboboxVariants = cva(
  [
    "group h-full w-full justify-start rounded-lg border-text-primary bg-white px-3 font-normal text-text-primary outline-2 hover:bg-neutral-50 focus:outline-offset-4 focus:outline-focus active:bg-neutral-100 aria-readonly:cursor-default aria-readonly:hover:bg-white aria-readonly:focus:outline-none aria-readonly:active:bg-white",
  ],
  {
    variants: {
      size: {
        xs: "py-1 text-xs",
        s: "min-h-8 py-1 text-sm",
        m: "min-h-10 py-1.5 text-base",
        l: "py-2.5 text-lg",
        xl: "px-4 py-3 text-xl",
      },
      disabled: {
        true: "border-neutral-200 pointer-events-none bg-white text-text-disabled [&_svg]:text-text-disabled",
        false: "",
      },
      multiple: {
        true: "",
        false: "",
      },
    },
    compoundVariants: [
      { multiple: true, size: "xs", class: "pl-1" },
      { multiple: true, size: "s", class: "pl-1" },
      { multiple: true, size: "m", class: "pl-1.5" },
      { multiple: true, size: "l", class: "pl-2.5" },
      { multiple: true, size: "xl", class: "pl-3" },
    ],
  },
);

export const comboboxMultipleItemVariants = cva(["text-xs"], {
  variants: {
    size: {
      xs: "text-xs",
      s: "text-xs",
      m: "text-sm",
      l: "text-sm",
      xl: "text-base",
    },
  },
});
